import { BasicResult } from "../basic-result";
import { CompletedCampaign } from "./completed-campaign";

export class CompletedCampaignResult extends BasicResult {
    public Campaign: CompletedCampaign;
    constructor(values: Object = {}) {
        super();
        Object.assign(this, values);

    }
}